import {
  normalizeNcrmActivityItem,
  normalizeNcrmActivityOriginEntityType,
  parseNcrmActivityEntityId,
} from "./ncrmActivity.mjs";

export const ncrmActivityTimelineActionMethods = {
  activityDisplayContent(activity) {
    const rawContent = String(activity?.content || "").trim();
    if (!rawContent) return "";
    if (this.normalizedEntityContext !== "onboarding") return rawContent;
    const sanitized = rawContent
      .split("\n")
      .map((line) => String(line || "").trim())
      .filter((line) => line && !/^Onboarding\s+#\d+$/i.test(line) && !/^Contract\s+Nr\.?\s+/i.test(line) && !/^Contract\s+\S+/i.test(line))
      .join("\n")
      .trim();
    return sanitized || "";
  },
  resolveActivityTitle(activity) {
    const title = String(activity?.title || "").trim();
    if (title) return title;
    const content = typeof this.activityDisplayContent === "function"
      ? String(this.activityDisplayContent(activity) || "").trim()
      : String(activity?.content || "").trim();
    if (content) {
      return content.length > 72 ? `${content.slice(0, 72)}...` : content;
    }
    return this.activityTypeLabel(activity?.activity_type);
  },
  isReadOnlyOriginLeadActivity(activity) {
    if (this.normalizedEntityType !== "deal") return false;
    const normalized = normalizeNcrmActivityItem(activity || {});
    return normalized.entity_type !== "deal" && normalized.origin_entity_type === "lead_entry";
  },
  canManageActivity(activity) {
    return !this.isReadOnlyOriginLeadActivity(activity);
  },
  activityOriginContext(activity) {
    const normalizedOriginType = normalizeNcrmActivityOriginEntityType(activity?.origin_entity_type);
    if (normalizedOriginType !== "lead_entry") return "";
    const boardName = String(activity?.origin_board_name || "").trim() || this.$t("ncrm.activity.origin.unknownBoard");
    const stageName = String(activity?.origin_stage_name || "").trim() || this.$t("ncrm.activity.origin.unknownStage");
    return this.$t("ncrm.activity.origin.leadEntryLabel", { board: boardName, stage: stageName });
  },
  activityOriginRoute(activity) {
    const normalizedOriginType = normalizeNcrmActivityOriginEntityType(activity?.origin_entity_type);
    const originEntityId = parseNcrmActivityEntityId(activity?.origin_entity_id);
    if (normalizedOriginType !== "lead_entry" || !originEntityId) return null;
    return {
      name: "NcrmLeadDetails",
      params: { id: String(originEntityId) },
      query: { tab: "activity" },
    };
  },
  openOriginContext(activity) {
    const route = this.activityOriginRoute(activity);
    if (!route || !this.$router) return;
    this.$router.push(route).catch(() => {});
  },
};
